import ToggleItem from './toggle_item';

export default class CellSlash extends ToggleItem {
  constructor() {
    super('cellslash');
  }
}
